import { useState, useCallback } from 'react';
import * as Location from 'expo-location';

export type PermissionStatus = 'undetermined' | 'requesting' | 'granted' | 'denied';

export interface UseLocationPermissionReturn {
  status: PermissionStatus;
  requestPermission: () => Promise<boolean>;
}

export function useLocationPermission(): UseLocationPermissionReturn {
  const [status, setStatus] = useState<PermissionStatus>('undetermined');

  const requestPermission = useCallback(async (): Promise<boolean> => {
    setStatus('requesting');
    try {
      const { status: permissionStatus } = await Location.requestForegroundPermissionsAsync();
      const granted = permissionStatus === 'granted';
      setStatus(granted ? 'granted' : 'denied');
      return granted;
    } catch {
      setStatus('denied');
      return false;
    }
  }, []);

  return { status, requestPermission };
}
